// API configuration and utilities for frontend
const API_BASE_URL = 'https://cp.fxpool.io/api';

// API call helper with error handling
export const apiCall = async (endpoint, method = 'GET', body = null) => {
  try {
    const config = { 
      method,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      mode: 'cors' // Enable CORS
    };

    if (body) {
      config.body = JSON.stringify(body);
    }

    const response = await fetch(`${API_BASE_URL}/${endpoint}`, config);
    
    // Handle non-JSON responses
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      throw new Error('Server returned non-JSON response');
    }
    
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `HTTP ${response.status}: ${response.statusText}`);
    }

    return data;
  } catch (error) {
    console.error('API Error:', error);
    
    // Handle specific error types
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('Unable to connect to server. Please check your internet connection.');
    }
    
    if (error.message.includes('CORS')) {
      throw new Error('Cross-origin request blocked. Please check server CORS configuration.');
    }
    
    throw error;
  }
};

// API endpoints
export const API_ENDPOINTS = {
  // Chat endpoints
  CHAT_MESSAGES: (chatId) => `chat.php?action=messages&chat_id=${chatId}`,
  CHAT_ACTIVE: 'chat.php?action=active_chats',
  CHAT_HISTORY: (userId) => `chat.php?action=chat_history&user_id=${userId}`,
  SEND_MESSAGE: 'chat.php',
  START_CHAT: 'chat.php',
  
  // Deposits endpoints
  USER_BALANCE: (userId) => `deposits.php?action=user_balance&user_id=${userId}`,
  DEPOSIT_HISTORY: (userId) => `deposits.php?action=deposit_history&user_id=${userId}`,
  PENDING_DEPOSITS: 'deposits.php?action=pending_deposits',
  PAYMENT_METHODS: 'deposits.php?action=payment_methods',
  BTC_RATES: 'deposits.php?action=btc_rates',
  CREATE_DEPOSIT: 'deposits.php',
  CONFIRM_DEPOSIT: 'deposits.php',
  
  // Rentals endpoints
  ASIC_MODELS: 'rentals.php?action=asic_models',
  AVAILABLE_ASICS: 'rentals.php?action=available_asics',
  USER_RENTALS: (userId) => `rentals.php?action=user_rentals&user_id=${userId}`,
  RENTAL_DETAILS: (rentalId) => `rentals.php?action=rental_details&rental_id=${rentalId}`,
  RENTAL_EARNINGS: (rentalId) => `rentals.php?action=rental_earnings&rental_id=${rentalId}`,
  CREATE_RENTAL: 'rentals.php',
  CALCULATE_EARNINGS: 'rentals.php'
};

export default API_BASE_URL;